import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    //background-color: red;
    //height: 40px;
    //width: 300px;
    gap: 20px;
    align-items: center;

    @media screen and (max-width: 1024px) {
        display: none;
    }
`

export const ItemData = styled.div`
    display: flex;
    height: 40px;
    align-items: center;
` 